/* =========================================================================
    Colors
========================================================================= */

export const BASE_FONT_SIZE = 16;

/**
 * @deprecated Use @ordermentum/ui-shared/foundations/color
 */
export const GRAYS_LIGHT_TO_DARK = {
  GRAY_ALABASTER: '#f7f7f7', // Almost white
  GRAY_LIGHT: '#f0f2f3',
  GRAY_MERCURY: '#e5e5e5',
  GRAYISH: '#a7a7a7',
  GRAY: '#919191',
  GRAY_MEDIUM: '#484849',
  GRAY_CHARCOAL: '#3e4149',
};

/**
 * @deprecated Use @ordermentum/ui-shared/foundations/color
 */
export const BASE = {
  WHITE: '#ffffff',
  BLACK: '#000000',
  ORANGE: '#ff5500',
  ORANGE_LIGHT: '#faa174',
  ORANGE_ULTRALIGHT: '#f7c9b0',
  GOLDEN_YELLOW: '#f6c923',
  WARNING: '#FEF9E8',
  ERROR: '#F6C923',
  INFO: '#F7F7F7',
  WIDGET_GRAY: '#F5F6F7',
  MUSTARD_YELLOW: '#CBA000',
  GREEN: '#34f794',
  RED: '#dd0000',
  RED_LIGHT: '#ff7575',
  ROSE_WHITE: '#fff4f0',
  BLUE: '#4A90E2',
  GRAY_ALICE_BLUE: '#e7f4fc', // More blue
  DISABLED: GRAYS_LIGHT_TO_DARK.GRAY_LIGHT,
};

/**
 * @deprecated Use @ordermentum/ui-shared/foundations/color
 */
export const BRAND = {
  PRIMARY: BASE.ORANGE,
  PRIMARY_LIGHT: BASE.ORANGE_LIGHT,
  PRIMARY_ULTRALIGHT: BASE.ORANGE_ULTRALIGHT,
};

/**
 * @deprecated Use @ordermentum/ui-shared/foundations/color
 */
export const SEMANTIC = {
  SUCCESS: BASE.GREEN,
  ERROR: BASE.RED,
};

/**
 * @deprecated Use @ordermentum/ui-shared/foundations/color
 */
export const COLOR = {
  ...GRAYS_LIGHT_TO_DARK,
  ...BRAND,
  ...SEMANTIC,
  ...BASE,
};

/**
 * @deprecated Use @ordermentum/ui-shared/foundations/color
 */
export const TEXT_COLOR_LIGHT = COLOR.GRAYISH;

/* =========================================================================
   Scaffolding
========================================================================= */
export const CARD = {
  PADDING: '1rem',
  BORDER_RADIUS: '4px',
  MIN_HEIGHT: '100px',
};

export const SHADOW = {
  CARD: '0 0 2px 1px rgba(0, 0, 0, 0.11)',
  BOX: '0 0 0.5px rgba(20, 20, 20, 0.3)',
  INPUT: 'inset 0 1px 2px 0 rgba(0, 0, 0, 0.25)',
};

/* =========================================================================
   Z-Index
========================================================================= */
const Z_INDEX_APP_HEADER = 15;
export const Z_INDEX = {
  APP_HEADER: Z_INDEX_APP_HEADER,
  NAV_PANEL: Z_INDEX_APP_HEADER + 1,
};

/* =========================================================================
   Heights and Widths
========================================================================= */
export const HEADER_CONTAINER_HEIGHT = '50px';
export const SEARCH_INPUT_HEIGHT = '43px';
export const NAV_ICON_CONTAINER_HEIGHT = '40px';
export const NAV_WIDTH = '14.5rem';
export const GLOBAL_SEARCH_WIDTH = '25.25rem';
export const NAV_RIGHT_GUTTER = '0.5rem';
export const APP_MAX_WIDTH = '85.72rem';
export const DASHBOARD_HEADER_HEIGHT = '3.75rem';

export const APP = {
  HEADER_HEIGHT: '50px',
  HEADER_HEIGHT_WITH_PADDING: 'calc(50px + 2rem)',
};

export const MAX_TOTAL_CARD_WIDTH_NEW_PAGE = '1300px'; // width with two card panels
export const MAX_WIDTH_SINGLE_CARD = '796px'; // width of panel with a single card

export const HEIGHT = {
  CARD_ROW: '3rem',
  CARD_ROW_SHORT: '2rem',
  INPUT: '35px', // with a html font size of 16px, this is 2.1875rem
};
export const PADDING = {
  CARD_HEADER: '1.3rem 1rem',
  CARD_ROW: '1rem',
  CARD_ROW_LR: '1rem',
  INPUT_LR: '0.5rem',
  FORM: '2rem',
  FORM_NARROW: '1rem',
};

/* =========================================================================
   Borders
========================================================================= */
export const BORDER_COLOR = COLOR.GRAY_LIGHT;
export const BORDER_RADIUS = {
  RESET: '0px', // Note(marco) glamor issue - if we rename to `NONE` it will not apply this rule
  SMALL: '2px',
  MEDIUM: '4px',
  LARGE: '6px',
};

export const DIVIDER_BORDER_TOP = `1px solid ${COLOR.GRAY_LIGHT}`;

/* =========================================================================
    Typography
========================================================================= */

/**
 * @deprecated Use @ordermentum/ui-shared/foundations/font
 */
export const LETTER_SPACING = {
  SMALL_TITLE: '0.75px',
};

/**
 * @deprecated Use @ordermentum/ui-shared/foundations/font
 */
export const FONT_WEIGHT = {
  LIGHT: 300,
  MEDIUM: 400,
  BOLD: 700,
};

/**
 * @deprecated Use @ordermentum/ui-shared/foundations/font
 */
export const FONT_FAMILY = {
  STANDARD: {
    HEADING: `"Lato", "Open Sans", "Avenir", "Avenir LT Std", "Helvetica Neue", Helvetica, sans-serif`,
  },
  FUTURO: {
    HEADING: `"Montserrat", "Open Sans", "Avenir", "Avenir LT Std", "Helvetica Neue", Helvetica, sans-serif`,
  },
};

/**
 * @deprecated Use @ordermentum/ui-shared/foundations/font
 */
export const FONT_SIZE = {
  LARGE: '2rem',
  MEDIUM_LARGE: '1.5rem',
  MEDIUM: '1.25rem', // 20px
  BASE: '1rem', // 16px
  SMALL: '0.875rem', // 14px
  X_SMALL: '0.65rem',
  SUFFIX: '0.5625rem', // 9px
};

export const LINK_HOVER_STYLE = {
  color: COLOR.ORANGE,
  textDecoration: 'underline',
};

export const ICON_SIZE = {
  BASE: '1.75rem',
};

/* =========================================================================
    Breakpoints
========================================================================= */
/**
 * @deprecated use @ordermentum/ui-shared/foundations/grid where possible
 */
export const MOBILE_MIN = 320;
/**
 * @deprecated use @ordermentum/ui-shared/foundations/grid where possible
 */
export const MOBILE_MAX = 480;
/**
 * @deprecated use @ordermentum/ui-shared/foundations/grid where possible
 */
export const TABLET_MIN = 768;
/**
 * @deprecated use @ordermentum/ui-shared/foundations/grid where possible
 */
export const TABLET_MAX = 1024;
/**
 * @deprecated use @ordermentum/ui-shared/foundations/grid where possible
 */
export const DESKTOP = 1224;
/**
 * @deprecated use @ordermentum/ui-shared/foundations/grid where possible
 */
export const DESKTOP_LARGE_MIN = 1600;

/**
 * @deprecated use @ordermentum/ui-shared/foundations/grid where possible
 */
export const BREAKPOINTS = {
  MOBILE_MIN: `${MOBILE_MIN}px`,
  MOBILE_MAX: `${MOBILE_MAX}px`,
  TABLET_MIN: `${TABLET_MIN}px`,
  TABLET_MAX: `${TABLET_MAX}px`,
  SHOW_SIDENAV: `${TABLET_MAX}px`,
  DESKTOP: `${DESKTOP}px`,
  DESKTOP_LARGE_MIN: `${DESKTOP_LARGE_MIN}px`,
};
